<template>
  <section class="contact">
    <TheHeader />
    <div class="contact__grid">
      <div class="contact__grid__colum1">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="309.5"
          height="111.559"
          viewBox="0 0 309.5 111.559"
        >
          <g id="contato" transform="translate(-146 -285.987)">
            <g
              id="Grupo_2831"
              data-name="Grupo 2831"
              transform="translate(137.868 -280.01)"
            >
              <path
                id="Caminho_4908"
                data-name="Caminho 4908"
                d="M168.99,580.864a11.33,11.33,0,0,0-.821-2.1,9.162,9.162,0,0,0-4.577-4.354,2.92,2.92,0,0,0-1.225-.5l-6.974-1.09a2.991,2.991,0,0,0-3.413,2.464l-5.533,33.1a3,3,0,0,0,2.449,3.45l6.429,1.1a3,3,0,0,0,.508.037l.1-.015c.239.022.478.06.717.06a9.1,9.1,0,0,0,6.243-2.658,11.332,11.332,0,0,0,1.471-1.732,12.032,12.032,0,0,0,1.367.112,11.576,11.576,0,0,0,4-.709l-.754,4.525c-.022.172-.575,4.107-5.421,7.706-4.779,3.547-14.165,7-32.281,5.511a8.483,8.483,0,0,0-6.646-4.846c-4.443-.747-8.513,1.478-9.1,4.958s2.546,6.9,6.989,7.646a8.8,8.8,0,0,0,7.31-1.852q5.164.47,9.79.47c12.142,0,21.454-2.442,27.808-7.31s7.355-10.447,7.49-11.522l2.718-16.279-.037-.007.47-2.793A11.724,11.724,0,0,0,168.99,580.864Zm3.159,12.373-.784,4.727a5.717,5.717,0,0,1-4.63,4.66l2.561-15.3A5.712,5.712,0,0,1,172.149,593.237Zm-13.4,12.784a3.025,3.025,0,0,1-2.4.971l-.007.03h-.008l-3.487-.6L157.4,579.2l3.495.545-.007.068a3.066,3.066,0,0,1,1.964,1.71,7.427,7.427,0,0,1,.582,4.517l-2.658,15.9A7.426,7.426,0,0,1,158.753,606.021Z"
                transform="translate(34.421 43.894)"
                fill="#f6d419"
              />
              <path
                id="Caminho_4909"
                data-name="Caminho 4909"
                d="M127.335,575.116a3.006,3.006,0,0,0-3.51-2.33l-6.922,1.359a2.886,2.886,0,0,0-1.217.553,9.175,9.175,0,0,0-4.4,4.525,13.272,13.272,0,0,0-.851,8.3l3.271,15.786c1.18,5.675,5.526,9.7,10.118,9.7a7.37,7.37,0,0,0,.911-.1l.09.015a2.973,2.973,0,0,0,.62-.067l6.385-1.344a3,3,0,0,0,2.315-3.539Zm-3.129,31.878-.008-.023c-1.635.336-3.958-1.68-4.622-4.884L116.305,586.3a7.411,7.411,0,0,1,.4-4.532,3.024,3.024,0,0,1,1.9-1.777l-.015-.075,3.472-.68,5.608,27.025Z"
                transform="translate(0 43.541)"
                fill="#f6d419"
              />
              <path
                id="Caminho_4910"
                data-name="Caminho 4910"
                d="M200.356,613.752a13.6,13.6,0,0,1,2.419,1.479c-.06-15.584-3.808-27.667-11.164-35.948-7.811-8.8-19.624-13.269-35.208-13.284-15.48.015-27.286,4.488-35.1,13.284-7.445,8.386-11.186,20.669-11.156,36.537a13.636,13.636,0,0,1,2.875-2.031,7.9,7.9,0,0,1,2.83-1.143l.545-.112c.433-12.612,3.6-22.417,9.558-29.159a10.135,10.135,0,0,0,5.137,5.667,9.615,9.615,0,0,0,3.928.8,13.252,13.252,0,0,0,6.78-2,22.869,22.869,0,0,1,3.427-1.613l.052-.029a37.731,37.731,0,0,1,22.365,0l.052.037a21.983,21.983,0,0,1,3.427,1.6,13.252,13.252,0,0,0,6.78,2,9.579,9.579,0,0,0,3.92-.8,10.11,10.11,0,0,0,5.145-5.675l.022.023c5.907,6.653,9.088,16.458,9.573,29.19l.948.149A7.933,7.933,0,0,1,200.356,613.752Zm-21.05-30.362a3.39,3.39,0,0,1-1.389.268,6.113,6.113,0,0,1-1.77-.291,32.274,32.274,0,0,0-6.183-2.889l-.2-.075-.082.15.06-.157-.045-.008a40.893,40.893,0,0,0-13.187-2.068v.015l-.1-.023-.037.008a41.2,41.2,0,0,0-13.165,2.068l-.246.09a31.783,31.783,0,0,0-6.153,2.875,6.07,6.07,0,0,1-1.807.306,3.354,3.354,0,0,1-1.381-.268c-1.523-.68-2.248-2.778-2.584-4.473,6.392-4.466,14.95-6.728,25.426-6.736,10.484.008,19.034,2.27,25.434,6.736C181.545,580.612,180.821,582.71,179.305,583.39Z"
                transform="translate(0.069 0)"
                fill="#f6d419"
              />
            </g>
            <g
              id="Grupo_2843"
              data-name="Grupo 2843"
              transform="translate(-5972 463)"
            >
              <g
                id="Grupo_2832"
                data-name="Grupo 2832"
                transform="translate(5932 -423)"
              >
                <line
                  id="Linha_296"
                  data-name="Linha 296"
                  y2="24"
                  transform="translate(243.5 313.5)"
                  fill="none"
                  stroke="#b3b4b4"
                  stroke-linecap="round"
                  stroke-width="6"
                />
                <line
                  id="Linha_297"
                  data-name="Linha 297"
                  y2="24"
                  transform="translate(255.5 325.5) rotate(90)"
                  fill="none"
                  stroke="#b3b4b4"
                  stroke-linecap="round"
                  stroke-width="6"
                />
              </g>
              <g
                id="Grupo_2833"
                data-name="Grupo 2833"
                transform="translate(5898 -467)"
              >
                <line
                  id="Linha_296-2"
                  data-name="Linha 296"
                  y2="24"
                  transform="translate(243.5 313.5)"
                  fill="none"
                  stroke="#fff"
                  stroke-linecap="round"
                  stroke-width="6"
                />
                <line
                  id="Linha_297-2"
                  data-name="Linha 297"
                  y2="24"
                  transform="translate(255.5 325.5) rotate(90)"
                  fill="none"
                  stroke="#fff"
                  stroke-linecap="round"
                  stroke-width="6"
                />
              </g>
              <g
                id="Grupo_2834"
                data-name="Grupo 2834"
                transform="translate(6140 -423)"
              >
                <line
                  id="Linha_296-3"
                  data-name="Linha 296"
                  y2="24"
                  transform="translate(243.5 313.5)"
                  fill="none"
                  stroke="#fff"
                  stroke-linecap="round"
                  stroke-width="6"
                />
                <line
                  id="Linha_297-3"
                  data-name="Linha 297"
                  y2="24"
                  transform="translate(255.5 325.5) rotate(90)"
                  fill="none"
                  stroke="#fff"
                  stroke-linecap="round"
                  stroke-width="6"
                />
              </g>
              <g
                id="Grupo_2835"
                data-name="Grupo 2835"
                transform="translate(6169 -461)"
              >
                <line
                  id="Linha_296-4"
                  data-name="Linha 296"
                  y2="24"
                  transform="translate(243.5 313.5)"
                  fill="none"
                  stroke="#b3b4b4"
                  stroke-linecap="round"
                  stroke-width="6"
                />
                <line
                  id="Linha_297-4"
                  data-name="Linha 297"
                  y2="24"
                  transform="translate(255.5 325.5) rotate(90)"
                  fill="none"
                  stroke="#b3b4b4"
                  stroke-linecap="round"
                  stroke-width="6"
                />
              </g>
              <g
                id="Elipse_206"
                data-name="Elipse 206"
                transform="translate(6349 -148)"
                fill="none"
                stroke="#b3b4b4"
                stroke-width="3"
              >
                <circle cx="6.5" cy="6.5" r="6.5" stroke="none" />
                <circle cx="6.5" cy="6.5" r="5" fill="none" />
              </g>
              <circle
                id="Elipse_207"
                data-name="Elipse 207"
                cx="4"
                cy="4"
                r="4"
                transform="translate(6118 -87)"
                fill="#fff"
              />
            </g>
          </g>
        </svg>

        <div class="contact__grid__colum1__text">
          <h1>ENTRE EM CONTATO</h1>
          <p>
            <strong>Central de Vendas:</strong>
            <a href="tel:08007292076">0800 729 2076</a>
          </p>

          <p>
            <strong>SAC:</strong>
            <a href="tel:08002838916">0800 283 8916</a>
          </p>
        </div>
      </div>
      <div class="contact__grid__colum2">
        <form @submit.prevent="handleSubmit()" class="form">
          <div
            class="form__group"
            :class="{ 'form__group--error': $v.field.subject.$error }"
          >
            <div class="select">
              <select v-model.trim="$v.field.subject.$model">
                <option :value="null" selected disabled hidden>
                  Selecione o assunto
                </option>
                <option :value="option" v-for="option in options" :key="option">
                  {{ option }}
                </option>
              </select>
            </div>
          </div>

          <div
            class="form__group"
            :class="{ 'form__group--error': $v.field.name.$error }"
          >
            <input
              type="text"
              v-model.trim="$v.field.name.$model"
              placeholder="*Nome"
            />
          </div>
          <div
            class="form__group"
            :class="{ 'form__group--error': $v.field.email.$error }"
          >
            <input
              type="email"
              v-model.trim="$v.field.email.$model"
              placeholder="*E-mail"
            />
          </div>
          <div
            class="form__group"
            :class="{ 'form__group--error': $v.field.cpf.$error }"
          >
            <input
              type="text"
              v-model.trim="$v.field.cpf.$model"
              placeholder="CPF"
              v-mask="'###.###.###-##'"
            />
          </div>
          <div
            class="form__group"
            :class="{ 'form__group--error': $v.field.telefone.$error }"
          >
            <input
              type="text"
              v-model.trim="$v.field.telefone.$model"
              placeholder="Telefone"
              v-mask="['(##) ####-####', '(##) #####-####']"
            />
          </div>
          <div
            class="form__group"
            :class="{ 'form__group--error': $v.field.zipcode.$error }"
          >
            <input
              type="text"
              v-model.trim="$v.field.zipcode.$model"
              placeholder="*CEP"
              v-mask="'##.###-###'"
            />
          </div>
          <div class="form__group">
            <textarea
              v-model.trim="field.message"
              cols="30"
              rows="5"
              placeholder="Sua mensagem"
              :class="{ 'form__group--error': $v.field.message.$error }"
            ></textarea>
          </div>
          <div class="contact__erros" v-if="$v.$error">
            <TheAlert v-if="!$v.field.subject.required"
              >Selecione o assunto que você deseja.</TheAlert
            >
            <TheAlert v-if="!$v.field.name.required"
              >Entre com o seu nome.</TheAlert
            >
            <TheAlert v-if="!$v.field.email.required"
              >Entre com o seu email.</TheAlert
            >
            <TheAlert v-if="!$v.field.email.email">E-mail inválido.</TheAlert>
            <TheAlert v-if="!$v.field.cpf.required"
              >Entre com seu CPF.</TheAlert
            >
            <TheAlert v-if="!$v.field.cpf.minLength"
              >Preencha o CPF corretamente.</TheAlert
            >
            <TheAlert v-if="!$v.field.telefone.required"
              >Entre com o seu telefone.</TheAlert
            >
            <TheAlert v-if="!$v.field.telefone.minLength"
              >Preencha o telefone corretamente.</TheAlert
            >
            <TheAlert v-if="!$v.field.zipcode.required"
              >Entre com o seu CEP.</TheAlert
            >
            <TheAlert v-if="!$v.field.zipcode.minLength"
              >Preencha o CEP corretamente.</TheAlert
            >
            <TheAlert v-if="!$v.field.message.minLength"
              >Preencha a mensagem corretamente.</TheAlert
            >
          </div>
          <button type="submit" :disabled="loading">
            {{ loading ? "Enviando..." : "Enviar" }}
          </button>
        </form>
        <div class="contact__grid__colum2__msg" v-if="send">
          <p>{{ sendMsg }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import { required, minLength, email } from "vuelidate/lib/validators";
export default {
  title() {
    return `Contato | Cartão de TODOS Clube do Bahia`;
  },
  data() {
    return {
      options: ["Solicitação", "Reclamação", "Informação", "Outros"],
      send: false,
      sendMsg: null,
      loading: false,
      field: {
        page: "cdtc",
        subject: null,
        name: null,
        email: null,
        cpf: null,
        telefone: null,
        zipcode: null,
        message: null,
      },
    };
  },
  validations: {
    field: {
      subject: {
        required,
      },
      name: {
        required,
      },
      email: {
        required,
        email,
      },
      cpf: {
        required,
        minLength: minLength(14),
      },
      telefone: {
        required,
        minLength: minLength(14),
      },
      zipcode: {
        required,
        minLength: minLength(10),
      },
      message: {
        required,
        minLength: minLength(10),
      },
    },
  },
  components: {
    TheAlert: () => import("@/components/TheAlert.vue"),
  },
  methods: {
    handleSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loading = true;
        axios
          .post("https://cartaodetodosBahia.com.br/mail/post.php", this.field)
          .then((response) => {
            if (!response.data.error) {
              this.sendMsg = "Sua mensagem foi enviada com sucesso!";
            } else {
              this.sendMsg =
                "Sua mensagem não pode ser enviada no momento, por favor, tente novamente!";
            }
          })
          .finally(() => {
            this.$v.$reset();
            this.send = true;
            this.loading = false;
            this.field.subject = null;
            this.field.name = null;
            this.field.email = null;
            this.field.cpf = null;
            this.field.telefone = null;
            this.field.zipcode = null;
            this.field.message = null;
          });
      }
    },
  },
  created() {
    this.send = false;
  },
};
</script>

<style lang="scss">
.contact {
  margin-top: 68px;
  @include media("<=small") {
    background: $color-primary;
  }
  @include media(">=tablet") {
    margin-top: 105px;
  }
  &__erros {
    margin-top: 20px;
  }
  &__grid {
    display: grid;
    grid-template-columns: 1fr;
    margin-top: -5px;
    @include media(">=tablet") {
      grid-template-columns: 44% auto;
    }

    &__colum1 {
      background: $color-primary;
      text-align: center;
      padding: 43px 0;
      @include media(">=tablet") {
        padding: 101px 0;
        background: $color-primary;
      }

      svg,
      &__text {
        display: block;
        margin: initial;
        margin-left: auto;
      }
      svg {
        margin-left: auto;
        margin-right: auto;

        @include media(">=tablet") {
          margin-right: 146px;
        }
      }
      &__text {
        @include media("<=small") {
          text-align: left;
          max-width: 300px;
          margin: 0 auto;
        }
        @include media(">=tablet") {
          width: 270px;
          margin-right: 166px;
          text-align: left;
        }

        h1 {
          font-family: "Arvo", sans-serif;
          font-weight: 700;
          font-size: 45px;
          color: $color-white;
          margin-top: 90px;
          @include media("<=small") {
            font-size: 34px;
            text-align: center;
          }
        }

        p {
          font-weight: 700;
          font-size: 20px;
          line-height: 30px;
          color: $color-white;
          margin-top: 25px;
          @include media("<=small") {
            font-size: 16px;
            max-width: 160px;
            margin: 20px auto;
          }

          a {
            text-decoration: none;
            font-weight: 400;
            color: $color-white;
            display: block;
            margin-top: 5px;
          }
        }
      }
    }

    &__colum2 {
      padding-top: 50px;
      background: $color-primary;
      @include media(">=tablet") {
        background: initial;
      }

      form {
        max-width: 538px;
        padding: 0 35px;
        margin: 0 auto;
        @include media(">=tablet") {
          padding: initial;
          margin-left: 90px;
        }
        select,
        textarea,
        input {
          font-family: "HelveticaNeue";
          border-radius: 10px;
          width: 100%;
          background: #f0f0f0;
          padding: 15px;
          border: none;
          margin: 0 0 12px;
          color: $color-gray;
          font-size: 14px;
          outline: none;
          appearance: none;
        }
        .select {
          position: relative;
          &::after {
            content: url("../assets/icons/arrow-select.svg");
            position: absolute;
            right: 20px;
            top: 40%;
            transform: translateY(-40%);
          }
        }
        button {
          padding: 10px 60px;
          border-radius: 20px;
          background: $color-yellow;
          color: $color-gray;
          border: none;
          width: 100%;
          font-size: 20px;
          margin-left: auto;
          width: 100%;
          font-family: "Arvo", serif;
          text-transform: uppercase;
          display: block;
          margin-bottom: 76px;
          transition: 0.3s ease-in-out;
          border: 2px solid $color-yellow;
          @include media(">=tablet") {
            margin-bottom: 20px;
            width: auto;
            &:hover {
              background: $color-gray;
              color: $color-yellow;
            }
          }
          &[disabled] {
            background: $color-gray;
            color: $color-gray;
            cursor: not-allowed;
          }
        }
      }
      &__msg {
        max-width: 538px;
        margin: 0px auto;
        display: block;
        background: $color-yellow;
        color: $color-white;
        padding: 10px 60px;
        border-radius: 20px;
        text-align: center;
        font-family: "Arvo", serif;
        font-size: 18px;
      }
    }
    button {
      outline: none;
      cursor: pointer;
    }
  }
}
</style>
